import React, { useState } from "react";
import axios from "axios";
import { Shuffle } from "lucide-react";
import { focusIncident } from "../lib/focusIncident";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const RandomButton = ({ compact = false }) => {
  const [busy, setBusy] = useState(false);
  const [last, setLast] = useState(null);

  const go = async () => {
    if (busy) return;
    setBusy(true);
    try {
      const r = await axios.get(`${API}/incidents/random`, { params: last ? { exclude: last } : {} });
      setLast(r.data.id);
      focusIncident(r.data.id);
    } catch (e) {
      console.error("random error", e);
    } finally {
      setBusy(false);
    }
  };

  if (compact) {
    return (
      <button
        onClick={go}
        data-testid="nav-random"
        className="brutal-press font-mono text-[12px] uppercase font-bold px-3 py-2 brutal-border bg-[#FF00FF] text-black inline-flex items-center gap-1.5"
        style={{ boxShadow: "3px 3px 0 0 #FFEA00", borderWidth: 3 }}
      >
        <Shuffle size={13} strokeWidth={3} className={busy ? "animate-spin" : ""} />
        Random
      </button>
    );
  }

  return (
    <button
      onClick={go}
      data-testid="cta-random"
      className="brutal-press inline-flex items-center gap-2 bg-[#FF00FF] text-black font-bold uppercase px-5 py-3 brutal-border"
      style={{ boxShadow: "6px 6px 0 0 #fff" }}
    >
      <Shuffle size={18} strokeWidth={3} className={busy ? "animate-spin" : ""} />
      Feed Me Cringe
    </button>
  );
};
